import { useState } from "react";
import useGet from "./read/useGet";

const useHasProductAccess = () => {
  const [hasAccess, setHasAccess] = useState(false);

  const { list } = useGet({
    url: `is_permission_for_product`,
    returnEntireResponse: true,
    onSuccess: (data) => {
      if (data?.status === 200) {
        setHasAccess(true);
      }
    },
    onError: (err) => {
      if (err?.response?.status === 403) {
        setHasAccess(false);
      }
    },
    initialData: {
      screen: "petty-cash",
    },
  });
  const { isLoading: isCheckingAccess } = list;

  return { isCheckingAccess, hasAccess };
};

export default useHasProductAccess;
